import {
	IntroductionTeam2,
	Team2SubtopicOne,
	Team2SubtopicOneActivityOne,
	Team2SubtopicOneActivityThree,
	Team2SubtopicOneActivityTwo,
	Team2SubtopicTwo,
	Team2SubtopicTwoActivityOne,
	Team2SubtopicTwoActivityTwo,
	Team2SubtopicTwoActivityFour,
	Home2,
	Team2SubtopicOneFinalPoints,
	Team2SubtopicTwoActivityThree,
	Team2SubtopicTwoActivityFive,
	Team2SubtopicTwoActivitySix,
	Team2SubtopicTwoActivitySeven,
	Team2SubtopicTwoActivityEight,
	Team2SubtopicTwoFinalPoints,
	SubtopicFinalTeam2,
} from "../pages";

export const pathTeam2 = {
	path: "home2",
	element: <Home2 />,
	children: [
		{
			path: "tema2",
			children: [
				{
					path: "introduction",
					element: <IntroductionTeam2 />,
				},
				{
					path: "subtema1",
					children: [
						{
							index: true,
							path: "intro",
							element: <Team2SubtopicOne />,
						},
						{
							path: "activityOne",
							element: <Team2SubtopicOneActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Team2SubtopicOneActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Team2SubtopicOneActivityThree />,
						},
						{
							path: "activityresult",
							element: <Team2SubtopicOneFinalPoints />,
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							index: true,
							path: "intro",
							element: <Team2SubtopicTwo />,
						},
						{
							path: "activityOne",
							element: <Team2SubtopicTwoActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Team2SubtopicTwoActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Team2SubtopicTwoActivityThree />,
						},
						{
							path: "activityFour",
							element: <Team2SubtopicTwoActivityFour />,
						},
						{
							path: "activityFive",
							element: <Team2SubtopicTwoActivityFive />,
						},
						{
							path: "activitySix",
							element: <Team2SubtopicTwoActivitySix />,
						},
						{
							path: "activitySeven",
							element: <Team2SubtopicTwoActivitySeven />,
						},
						{
							path: "activityEight",
							element: <Team2SubtopicTwoActivityEight />,
						},
						{
							path: "activityresult",
							element: <Team2SubtopicTwoFinalPoints />,
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTeam2 />,
				},
			],
		}
	]
}

